<template>
  <v-card flat>
    <v-card outline class="mt-10 py-4">
      <v-form>
        <v-card-title>Lägg till beskrivning</v-card-title>
        <v-select
          v-model="filterPart"
          :items="parts"
          label="Välj del"
          persistent-hint
          return-object
          single-line
          class="parts mx-auto"
        ></v-select>

        <v-textarea
          v-model="newItem"
          label="Beskrivning"
          class="text-field mx-auto"
          append-icon="mdi-file-document-box-plus-outline"
        />
      </v-form>

      <v-card-actions>
        <v-col class="mx-auto px-auto text-center" cols="12" md="6">
          <v-btn v-if="AddBtn" @click="clickAdd" type="submit" color="primary">Lägg till</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
// @group Common
// AddItem component
export default {
  name: 'AddItem',
  data: () => ({
    newItem: '',
    AddBtn: true,
    filterPart: '',
    parts: [
      {value: 1, text: 'Fakta'},
      {value: 2, text: 'Förståelse'},
      {value: 3, text: 'Färdighet'},
      {value: 4, text: 'Förmåga'}
    ]
  }),
  props: {
    //has element id 
    elementId: Number
  },
  methods: {
    clickAdd() {
       // Fire addItemClick event
      // @arg The argument is object representing item
      this.$emit(
        'addItemClick',
        this.filterPart.value,
        this.newItem,
        this.elementId
      )
      this.newItem = ''
    }
  }
}
</script>
<style lang="scss">
.parts {
  width: 90%;
}
</style>